"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapper = exports.image = exports.loader = void 0;

const loader = () => ({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 9
});

exports.loader = loader;

const image = () => ({
  maxWidth: '100%'
});

exports.image = image;

const wrapper = () => ({
  width: '100%'
});

exports.wrapper = wrapper;
//# sourceMappingURL=MediaStory.style.js.map